module.exports = __webpack_public_path__ + "static/media/bill.5d3ff927.svg";